import { ISelectedAddressRecord, GovAddressBox } from "@publicMirage/components/govReact/GovAddressBox";
import { GovField } from "@publicMirage/components/govReact/GovField";
import { useForm } from "@prePublicPortalWestLindsay/pages/form/hooks/formContext";
import { Button, Fieldset, HintText, LabelText } from "govuk-react";
import React, { memo, useCallback, useEffect } from "react";
import { getValuesWithNewLines } from "@shared/mirage/utils/getValuesWithNewLines";
import { useBoolean } from "@mirage/hooks/useBoolean";
import { PrePpWlFormComponentStepProps } from "../PrePublicPortalWlForm";
import Box from "@mui/material/Box";
export const PrePpWlAgentDetailsFormStep = memo((props: PrePpWlFormComponentStepProps) => {
    const { next } = props;
    const { toFieldProps, setFieldValue, formState, previous } = useForm();
    const { agentAddressLine1, agentAddressLine2, agentAddressLine3, agentPostTown, agentPostcode } = formState;
    const { value: addressEditable, toggle: toggleAddressEditable } = useBoolean(false);
    const updateGazetteerExtraFields = useCallback(
        (easting: string | number, northing: string | number, uprn: string) => {
            setFieldValue("agentEasting", easting);
            setFieldValue("agentNorthing", northing);
            setFieldValue("agentUprn", uprn);
        },
        [setFieldValue]
    );
    const gazeteerOnSelect = useCallback(
        ({ addressDetails, addressLines, point }: ISelectedAddressRecord) => {
            const { easting, northing } = point;
            const { UPRN, TOWN_NAME, POSTCODE } = addressDetails;
            const { line1, line2, line3 } = addressLines;
            const location = getValuesWithNewLines([line1, line2, line3, TOWN_NAME, POSTCODE]);
            if (!addressEditable) {
                updateGazetteerExtraFields(easting, northing, UPRN);
            }
            setFieldValue("agentAddressLine1", line1);
            setFieldValue("agentAddressLine2", line2);
            setFieldValue("agentAddressLine3", line3);
            setFieldValue("agentPostTown", TOWN_NAME);
            setFieldValue("agentPostcode", POSTCODE);
            setFieldValue("agentAddress", location);
        },
        [addressEditable, setFieldValue, updateGazetteerExtraFields]
    );

    useEffect(() => {
        if (addressEditable) {
            updateGazetteerExtraFields("", "", "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agentAddressLine1, agentAddressLine2, agentAddressLine3, agentPostTown, agentPostcode]);

    return (
        <>
            <Fieldset>
                <Fieldset.Legend size="LARGE">Agent details</Fieldset.Legend>
            </Fieldset>
            <HintText>If you don't have a planning agent, skip to the next section.</HintText>
            <GovField {...toFieldProps("agentTitle", "TEXT")} />
            <GovField {...toFieldProps("agentFirstName", "TEXT")} />
            <GovField {...toFieldProps("agentSurname", "TEXT")} />
            <GovField {...toFieldProps("agentPhoneNumber", "TEXT")} />
            <GovField {...toFieldProps("agentEmail", "TEXT")} />
            <GovField {...toFieldProps("agentCompany", "TEXT")} />
            <GovAddressBox onSelect={gazeteerOnSelect} />
            <GovField contentType="CHECKBOX" label="I want to enter the address by myself" value={addressEditable} onChange={toggleAddressEditable} />
            <LabelText>Address</LabelText>
            <GovField {...toFieldProps("agentAddressLine1", "TEXT")} label="" disabled={!addressEditable} />
            <GovField {...toFieldProps("agentAddressLine2", "TEXT")} label="" disabled={!addressEditable} />
            <GovField {...toFieldProps("agentAddressLine3", "TEXT")} label="" disabled={!addressEditable} />
            <GovField {...toFieldProps("agentPostTown", "TEXT")} disabled={!addressEditable} />
            <GovField {...toFieldProps("agentPostcode", "TEXT")} disabled={!addressEditable} />
            <Box display="flex" justifyContent="space-between">
                <Button onClick={previous}>Previous</Button>
                <Button onClick={next}>Next</Button>
            </Box>
        </>
    );
});
